var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.cssClass,attrs:{"to":{ name: _vm.routeName, params: { pathName: _vm.routeParam } }}},[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }